import React, { useContext } from "react";
import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import {
  Dashboard as DashboardIcon,
  Group as TeamsIcon,
  EventNote as CalendarIcon,
} from "@material-ui/icons";
import intl from "react-intl-universal";

import { UserContext, IUserContext } from "context/user";
import { routing } from "routing";

const { Urls } = routing;

export const SidebarList = () => {
  const history = useHistory();
  const { defaultTeam }: IUserContext = useContext(UserContext);

  const navigateTo = (url: string) => () => {
    history.push(url);
  };

  return (
    <List>
      <ListItem
        button
        disabled={defaultTeam < 0}
        onClick={navigateTo(Urls.PLATFORM())}
      >
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary={intl.get("SIDEBAR_OVERVIEW")} />
      </ListItem>
      <ListItem button onClick={navigateTo(Urls.TEAM_MANAGEMENT())}>
        <ListItemIcon>
          <TeamsIcon />
        </ListItemIcon>
        <ListItemText primary={intl.get("SIDEBAR_TEAMS")} />
      </ListItem>
      <ListItem
        button
        onClick={navigateTo(Urls.CALENDAR())}
        disabled={defaultTeam < 0}
      >
        <ListItemIcon>
          <CalendarIcon />
        </ListItemIcon>
        <ListItemText primary={intl.get("SIDEBAR_CALENDAR")} />
      </ListItem>
    </List>
  );
};
